export { default } from "./ConfirmModal.jsx"
